import axios from "axios";
import { appUrl } from "../../../../utils/config";

/**
 * Unified utility for fetching all dashboard filters from a single endpoint
 * @returns {Promise} Promise that resolves to filter data for all dashboards
 */
export const fetchAllDashboardFilters = async () => {
  try {
    const response = await axios.get(`${appUrl}/user/fetchAllFilters`);
    if (response?.data?.status) {
      return response.data;
    } else {
      return { status: false };
    }
  } catch (error) {
    console.error("Error fetching filters:", error);
    return { status: false };
  }
};

/**
 * Unified utility for saving filters for any dashboard
 * @param {string} dashboardType - Type of dashboard (poCollaborationDashboard, inventoryStatusDashboard, inventoryReconciliationDashboard)
 * @param {Object} filterData - Filter data to save
 * @returns {Promise} Promise that resolves to save operation status
 */
export const saveDashboardFilters = async (dashboardType, filterData) => {
  try {
    // Create the payload structure with dashboard type as key
    const payload = {
      [dashboardType]: filterData
    };
    
    const response = await axios.post(`${appUrl}/user/saveFilters`, payload);
    return response.data;
  } catch (error) {
    console.error("Error saving filters:", error);
    return { 
      status: false, 
      message: "Failed to save filters. Please try again later." 
    };
  }
};

/**
 * Helper function to extract filters for a specific dashboard
 * @param {Object} allFilters - All dashboard filters object
 * @param {string} dashboardType - Type of dashboard to extract filters for
 * @returns {Object} The filters for the specified dashboard
 */
export const extractDashboardFilters = (allFilters, dashboardType) => {
  if (allFilters?.status && allFilters?.data && allFilters.data[dashboardType]) {
    return {
      status: true,
      save_filter_options: allFilters.data[dashboardType]
    };
  }
  return { status: false };
};
